import React from 'react';
import { BookOpen, Database, Bot, Briefcase } from 'lucide-react';
export function SolutionSection() {
  const tomos = [{
    icon: <BookOpen className="w-10 h-10 text-white" data-id="element-177" />,
    title: 'Tomo I — Fundamentos',
    description: 'Domina la lógica de sistemas. Aprende a pensar en procesos y configura tu entorno profesional en n8n desde cero absoluto.',
    color: 'bg-blue-600'
  }, {
    icon: <Database className="w-10 h-10 text-white" data-id="element-178" />,
    title: 'Tomo II — Ingeniería de Datos',
    description: 'El cerebro de la máquina. Domina JSON, lógica condicional (IF/Switch) y manipulación de datos para flujos complejos.',
    color: 'bg-green-600'
  }, {
    icon: <Bot className="w-10 h-10 text-white" data-id="element-179" />,
    title: 'Tomo III — Ecosistemas con IA',
    description: 'Implementa soluciones reales. Integración de agentes de IA para ventas, atención al cliente y reportes automáticos que las empresas mueren por tener.',
    color: 'bg-purple-600'
  }, {
    icon: <Briefcase className="w-10 h-10 text-white" data-id="element-180" />,
    title: 'Tomo IV — El Negocio',
    description: 'Monetiza tu conocimiento. Cómo empaquetar tus servicios, poner precios premium y cerrar contratos de mantenimiento recurrente.',
    color: 'bg-brand-orange',
    highlight: true
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-181">
      <div className="max-w-6xl mx-auto" data-id="element-182">
        <div className="text-center mb-16" data-id="element-183">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-184">
            El Sistema Completo: <br className="hidden md:block" data-id="element-185" />
            <span className="text-brand-red" data-id="element-186">
              La Saga del Arquitecto No-Code.
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-187">
            4 tomos diseñados estratégicamente para llevarte de principiante a
            dueño de un negocio de automatización rentable.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-188">
          {tomos.map((tomo, index) => <div key={index} className={`relative bg-white rounded-xl shadow-lg border-2 transition-transform hover:-translate-y-2 duration-300 flex flex-col h-full ${tomo.highlight ? 'border-brand-orange shadow-brand-orange/20' : 'border-gray-100'}`} data-id="element-189">
              {tomo.highlight && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-orange text-white font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap shadow-md" data-id="element-190">
                  EL DIFERENCIADOR
                </div>}

              <div className={`p-6 ${tomo.color} rounded-t-lg flex justify-center`} data-id="element-191">
                <div className="bg-white/20 p-4 rounded-full backdrop-blur-sm" data-id="element-192">
                  {tomo.icon}
                </div>
              </div>

              <div className="p-6 flex-grow flex flex-col" data-id="element-193">
                <h3 className={`text-xl font-bold mb-4 ${tomo.highlight ? 'text-brand-orange' : 'text-gray-900'}`} data-id="element-194">
                  {tomo.title}
                </h3>
                <p className="text-gray-600 leading-relaxed flex-grow" data-id="element-195">
                  {tomo.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}